class ProgressiveWebAppHelper {
    static isProgressiveWebApp () {
        const isProgressiveWebApp = window.matchMedia('(display-mode: standalone)').matches;

        return isProgressiveWebApp;
    }
}

export default ProgressiveWebAppHelper;